import React from 'react';
import * as PropTypes from 'prop-types';

import Button from '../../../Button';
import styles from './styles.styl';

function PayaPaymentHandleResponse({
  onClose,
  options: { errorMessage, formatMessage, programName, success, dependentName },
}) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {!success &&
          (errorMessage ||
            formatMessage({ id: 'appointment.payment.errorTitle' }))}
        {success && formatMessage({ id: 'appointment.payment.successMessage' })}
      </div>
      <div className={styles.staticMessage}>
        {success
          ? formatMessage(
              {
                id: dependentName
                  ? 'program.membership.payaResponse.dependent.success'
                  : 'program.membership.payaResponse.success',
              },
              { programName, dependentName },
            )
          : formatMessage({ id: 'program.membership.payaResponse.static' })}
      </div>
      <Button
        raised
        color="primary"
        onClick={onClose}
        className={styles.button}
      >
        {formatMessage({ id: 'auth.errors.gotIt' })}
      </Button>
    </div>
  );
}

PayaPaymentHandleResponse.propTypes = {
  onClose: PropTypes.func,
  options: PropTypes.shape({
    errorMessage: PropTypes.string,
    formatMessage: PropTypes.func,
    programName: PropTypes.string,
    dependentName: PropTypes.string,
    success: PropTypes.bool,
  }),
};

export default PayaPaymentHandleResponse;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PayaPaymentHandleResponse/index.jsx